import {
    AtualizarCategoriasRespostaChatService,
    AtualizarRespostaChatService,
    CadastrarCategoriasRespostaChatService,
    CadastrarRespostaChatService,
    DeletarCategoriasRespostaChatService,
    DeletarRespostaChatService,
    GerarRelatorioPesquisaSatisfacaoHelpdeskService,
    GetCategoriasRespostaChatService,
    ListarCategoriasRespostaChatService,
    ListarPesquisaSatisfacaoService,
    ListarRespostaChatService,
} from "../../../Services/HelpDesk/GestaoRespostas/GestaoRespostasServices";

import {
    ICategorias,
    IListarPesquisaSatisfacao,
    IRespostaChat,
} from "../../../Interfaces/HelpDesk/GestaoRespostas/GestaoRespostasInterface";
import { Controller } from "../../Controller";

export async function ListarCategoriasRespostaChatController() {
    return Controller(ListarCategoriasRespostaChatService());
}

export async function DeletarCategoriasRespostaChatController(
    ID_CATEGORIA_RESPOSTA_CHAT: number
) {
    return Controller(
        DeletarCategoriasRespostaChatService(ID_CATEGORIA_RESPOSTA_CHAT)
    );
}

export async function GetCategoriasRespostaChatController(
    idCategoriaRespostaChat: number
) {
    return Controller(
        GetCategoriasRespostaChatService(idCategoriaRespostaChat)
    );
}

export async function CadastrarCategoriasRespostaChatController(
    requestBody: ICategorias
) {
    return Controller(CadastrarCategoriasRespostaChatService(requestBody));
}

export async function AtualizarCategoriasRespostaChatController(
    requestBody: ICategorias
) {
    return Controller(AtualizarCategoriasRespostaChatService(requestBody));
}

//resposta chat

export async function ListarRespostaChatController(
    idCategoriaRespostaChat: number
) {
    return Controller(ListarRespostaChatService(idCategoriaRespostaChat));
}

export async function CadastrarRespostaChatController(
    requestBody: IRespostaChat
) {
    return Controller(CadastrarRespostaChatService(requestBody));
}

export async function AtualizarRespostaChatController(
    requestBody: IRespostaChat
) {
    return Controller(AtualizarRespostaChatService(requestBody));
}

export async function DeletarRespostaChatController(idRespostaChat: number) {
    return Controller(DeletarRespostaChatService(idRespostaChat));
}

export async function ListarPesquisaSatisfacaoController(
    requestBody: IListarPesquisaSatisfacao,
    ID_TIPO_CASO: number
) {
    return Controller(
        ListarPesquisaSatisfacaoService(requestBody, ID_TIPO_CASO)
    );
}

export async function GerarRelatorioPesquisaSatisfacaoHelpdeskController(
    requestBody: IListarPesquisaSatisfacao,
    ID_TIPO_CASO: number
) {
    return Controller(
        GerarRelatorioPesquisaSatisfacaoHelpdeskService(
            requestBody,
            ID_TIPO_CASO
        )
    );
}
